import {
  Component, OnInit, ViewContainerRef,
  Injectable, ElementRef, ViewChild
} from '@angular/core';
import { AppService } from '../../../../../app.service';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerSelectItem, JobsiteSelectItem, EquipmentSelectItem, Equipment, EquipmentDetailsParams } from '../../../setup-equipment/setup-equipment.model';
import { GETSetupEquipmentService } from '../../../setup-equipment/setup-equipment.service';
import { SetupImplementService } from './../../setup-implement.service';
import { EquipmentService } from '../../../services/equipment.service';
import {
  TemplateViewModel,
  GenericIdName,
  ImplementDetails,
  MeasurementPointDetails,
  ObservationPointDetails,
  SaveImplementImageParams,
  SchematicDataVM,
  ComponentVM,
  ApplySelectionData,
  SaveImplementDetailParams,
  SaveMeasurementPointParams,
  SaveObservationPointParams,
  SaveComponentParams,
  SetupImplementPageConstants,
  SetupImplementErrorCodes,
  SaveModeltParams,
  SchematicImagesVM,
  saveNewImplementTypeVM,
  ValidationErrorStatus,
  SchematicUploadParams,
  SaveQuestionImageParams,
  ObservationPointVMEdit
} from './../../setup-implement.model';
import { ModelSelected } from '../../../entities/global/model';
import { NewImplementTemplate } from '../../../entities/implement-template.model';
import { DomSanitizer } from '@angular/platform-browser';
import 'rxjs/add/observable/forkJoin';
import { GETDeleteConfirmationDialogComponent } from './../../delete-confirmation-dialog/delete-confirmation-dialog.component';
import { CopyImplementDialogComponent } from './../../copy-implement-dialog/copy-implement-dialog.component';
import { EquipmentDetailsService } from '../../../equipment-details/equipment-details.service';
import { SelectionNewImplementComponent } from './../../add-new-componentType/add-new-componentType.component';
import { FamilyList } from '../../../favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../../../favourite-dialog/favourite-dialog.service';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { NotificationsService } from 'angular2-notifications';
import { SchematicViewService } from '../../../schematic-view/schematic-view.service';
import { SchemanticOpPopupEditComponent } from '../../../schemantic-op-popup-edit/schemantic-op-popup-edit.component';
import { componentListsVM } from '../../../equipment-details/equipment-details.model';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GETPreferencesService } from '../../../preferences/preferences.service';
import { SchematicCompsMarkingComponent } from '../../../schematic-comps-marking-popup/schematic-comps-marking.component';
import { SchemanticCompTypePopupComponent } from '../../../schemantic-op-popup/schemantic-comptype-popup.component';
import { heicTo } from 'heic-to';
import { ConfirmationBoxComponent } from '../../../../../shared/confirmation-box/confirmation-box.component';


@Component({
  selector: 'app-implement-component-setup',
  templateUrl: './implement-component-setup.component.html',
  styleUrls: ['./implement-component-setup.component.scss']
})
export class ImplementComponentSetupComponent implements OnInit {

  private _subscriptions: Subscription[] = [];
  private _equipmentId: number;
  private _implementId: number;
  oldGetUrl: string;
  setupComplete: boolean = false;
  isLinear: boolean = true;
  currentStep: number = 0;
  IsTemplate: boolean = false;
  loading: boolean = false;
  // Image uploaders
  @ViewChild('uploadImplementImage') ImplementImageUpload: ElementRef;
  @ViewChild('uploadSchematicImage') SchematicImageUpload: ElementRef;

  // Page constants
  pageConstants: SetupImplementPageConstants = new SetupImplementPageConstants();

  // Error codes
  pageErrors: SetupImplementErrorCodes = new SetupImplementErrorCodes();

  // Radio buttons
  newOrExistingOption: string = this.pageConstants.IMPLEMENT_SETUP_NEW;
  equipmentOrInventory: string = this.pageConstants.SETUP_ON_EQUIPMENT;

  // Models
  modelList_: GenericIdName[] = [];
  modelList: ModelSelected[] = [];
  modelListFiltered: ModelSelected[];
  modelListFilter: string;
  selectedModels: number[] = [];
  implementTemplateDetails: NewImplementTemplate;

  // Component Types
  componentList: ComponentVM[] = [];
  componentListFiltered: ComponentVM[];
  componentListFilter: string;
  selectedComponentsList: ComponentVM[] = [];
  newComponentName: string;
  newComponentMakeId: number;
  newComponentPartNo: string;
  newComponentCusPartNo: string;

  newComponentId: number = 1;
  newComponentCritical: boolean = true;
  isGETCritical: boolean
  cbAllComponentsSelect: boolean = true;
  cbAllObservationSelect: boolean = false;
  newComponentSchematicId: number;
  newComponentTypeId: number;
  newcompBudgetLife: number = 2000;

  // Save component - unsaved changes warning.
  unsavedChanges_ComponentSetup: boolean = false;
  unsavedChanges_OPSetup: boolean = false;
  unsavedChanges_ModelSetup: boolean = false;

  // Observation Point Types
  observationPointTypes: GenericIdName[] = [];
  observationPointListFilter: string;

  // Model loading Finished
  modelsLoaded: boolean = false;

  // Filter by selected or unselected.
  hideSelectedModels: boolean = false;
  hideUnselectedModels: boolean = false;
  hideSelectedMPs: boolean = false;
  hideUnselectedMPs: boolean = false;
  hideSelectedOPs: boolean = false;
  hideUnselectedOPs: boolean = false;

  // Step 1
  customerList: CustomerSelectItem[] = [];
  jobsiteList: JobsiteSelectItem[] = [];
  equipmentList: EquipmentSelectItem[] = [];
  NewimplementType: string
  NewImplementImage: string = ""
  isNewImplement: boolean = false
  // User selections in input boxes
  selectedCustomer: number = 0;
  selectedJobsite: number = 0;
  selectedEquipment: number = 0;
  selectedMake: number = 0;
  selectedImplementType: number = 0;
  selectedImplement: number = 0;
  selectedSchematic: SchematicDataVM;
  selectedSchematicEdit: ObservationPointVMEdit
  selectedSchematicEdit_: SchematicDataVM[]
  NewSchematicId: number = 0;
  budgetHrs: number;
  bcmHrs: number;
  tonHrs: number;

  purchaseCost: number;
  // Preserve implement id, which gets lost after navigating away from the tab.
  attachedImplementSelected: number = this.selectedImplement;

  // Preserve previously selected implement type.
  prevSelectedImplementType: number = 0;

  // Step 2
  implementList: GenericIdName[] = [];
  implementTypeList: TemplateViewModel[] = [];
  makeList: GenericIdName[] = [];
  filtermakeList: GenericIdName[] = [];
  serialNumber: string = '';
  canChangeHoursAndDate: boolean = true;
  dateOfReading: Date = new Date();
  implementHours: number = 0;
  equipmentSMU: number = 0;
  Additional_serial_num: string = null;
  bucketCapacity: number;
  selectedGETType: number;
  implementImage: string = '';
  schematicList: SchematicDataVM[] = [];

  // Step 3
  //componentList: MeasurementPointDetails[] = [];
  observationLists: GenericIdName[] = [];
  observationPoints: ObservationPointDetails[] = [];
  observationListFiltered: ObservationPointDetails[] = []
  selectedObservationList: ObservationPointDetails[] = [];

  newOPName: string = "";
  newOPObservationListId: number = 0;
  newOPLimitNew: number = 0;
  newOPLimitScrap: number = 0;

  observationListFilter: string;
  observationListAfterChanages: ObservationPointDetails[]
  isvalidStep3: boolean = true


  // Right-click Context Menu
  showContextMenu: boolean = false;
  contextMenuX: string = "100px";
  contextMenuY: string = "100px";
  selectionData: ApplySelectionData = new ApplySelectionData();

  // Highlight for vacant or all cells, for the right-click context menu.
  showVacantCells: boolean = false;
  showAllCells: boolean = false;

  // Schematic window.
  showSchematic: boolean = false;
  schematicPositionX: number;
  schematicPositionY: number;
  draggableSchematicTitle: string = "Schematic";
  showObservation: boolean = true;

  // Pre-populate Make for Measurement Points of new Implement with the Equipment / Implement Make.
  prepopulateMake: number = 0;

  // Mouse events for draggable schematic window.
  isMouseDown: boolean = false;
  prevMouseX: number;
  prevMouseY: number;

  // Mouse-over highlight components and observation points.
  mouseoverMPId: number = 0;
  mouseoverOPId: number = 0;

  // Mouse-over highlight implement type replicate icon
  mouseoverITReplicate: boolean = false;

  observationListId: any;

  //tab3validation variables
  observationPointsOld: ObservationPointDetails[]
  cbApplyToAll: boolean = false
  cbApplyToOne: boolean = false
  AllChecked
  OneChecked
  public selectedIds: any
  public selectedId: any
  public array: any
  public haschanges: Boolean
  onlyInA: any

  //getSchematic Image name
  selectedSechamnticImage: File
  SelectedschematicImageList: SchematicImagesVM = new SchematicImagesVM();
  Imagelist: SchematicDataVM[] = []

  equipmentDetails: EquipmentDetailsParams;

  componentTypeList: GenericIdName[] = [];

  //tab4
  selectedMakeList: number[] = [];
  familyList: FamilyList[] = [];
  selectedFamilyList: number[] = [];

  selectedFamily: number[] = [];
  selectedMakes: number[] = [];
  target: any[] = [];
  source: any[] = [];

  NewMaxCrackLength: number
  colorCodeList: componentListsVM[]
  NewcolorCode: number
  SeverityList: componentListsVM[]
  Newseverity: number
  NewUOM: number = 1

  ShowHideSchOrder: boolean = false;

  UOM: any;

  constructor(private _appService: AppService,
    private _setupEquipmentService: GETSetupEquipmentService,
    private _implementService: SetupImplementService,
    private _route: ActivatedRoute, private _router: Router,
    private _sanitizer: DomSanitizer, private _snackBar: MatSnackBar,
    private _equipmentService: EquipmentService,
    public dialog: MatDialog, private toastr: NotificationsService,
    vcr: ViewContainerRef,
    public _equipmentDetailsService: EquipmentDetailsService,
    public _favouriteDialogService: FavouriteDialogService, public _dualList: AngularDualListBoxModule,
    public SchematicViewService_: SchematicViewService,
    public userPrefrence:  GETPreferencesService) {
  }

  ismodified: boolean = false;
  title: string = "";
  ngOnInit() {
    this._appService.setPageTitle('Setup Components');
    this._route.params.subscribe(params => {
      this.selectedImplement = +params['implementId'];
      this.attachedImplementSelected = this.selectedImplement;
    });
    this.loadImplementDetails();
    this.loadMakes();
    this.loadComponentTypes();
    this.loadImplementSchematics();
    this.loadGETComponents();
    //this.loadObservationPointTypes();
    //this.loadOLDObservationPointsForImplement();
    // this.loadOldGETComponents();
    this.unsavedChanges_ComponentSetup = true;
    this.getColorCodes();
    //this.getSeverityList();
    this.loadGETPurchaseCost();
  }

  loadGETPurchaseCost() {
    this._implementService.ReturnGETPurchaseCost(this.selectedImplement).subscribe(res => {
      this.purchaseCost = res;
    })
  }

  //Observation
  onObservationNameFilterChange() {
    if (this.observationListFilter != null && this.observationListFilter.length > 0) {
      this.observationListFiltered = this.observationPoints.filter(item => item.Name != null && item.Name.toLowerCase().includes(this.observationListFilter.toLowerCase()) ? true : false)
    } else {
      this.observationListFiltered = this.observationPoints;
    }
  }

  onObservationListControlChanged(id, name) {
    var ct = this.observationPoints.find(ct => ct.Id == id && ct.Name == name);
    if (ct != null) {
      ct.Selected = !ct.Selected;
    }
    this.selectedObservationList = this.observationPoints.filter(c => c.Selected).map(item => {
      let op: ObservationPointDetails = {
        Id: item.Id,
        Name: item.Name,
        ObservationPointType: item.ObservationPointType ? item.ObservationPointType : 0,
        ObservationListIds: item.ObservationListIds ? item.ObservationListIds : [],
        ObservationListId: item.ObservationListId,
        Selected: item.Selected,
        NumberOfReadings: item.NumberOfReadings,
        LimitNew: item.LimitNew,
        LimitScrap: item.LimitScrap,
        ComponentName: item.ComponentName,
        ComponentMake: item.ComponentMake,
        ComponentPartNo: item.ComponentPartNo,
        ComponentId: item.ComponentId,
        Active: item.Active,
        QuestionImage: item.QuestionImage,
        QuestionImagePath: item.QuestionImagePath,
        IsNewImage: item.IsNewImage,
        QName: item.QName,
        QDesc: item.QDesc,
        LimitRange: item.LimitRange,
        Measurement: item.Measurement,
        InspectionDate: item.InspectionDate,
        SortOrder: item.SortOrder,
        InspectionTypeID: item.InspectionTypeID,
        IsAnswer: item.IsAnswer,
        IsImage: item.IsImage,
        Xcoord: item.Xcoord,
        Ycoord: item.Ycoord,
        EndXcoord: item.EndXcoord,
        EndYcoord: item.EndYcoord,
        ComponentType: item.ComponentType,
        ComponentTypeId: item.ComponentTypeId,
        ComponentTypeSortOrder: item.ComponentTypeSortOrder,
        CrackSeverityListId: item.CrackSeverityListId
      }
      return op;
    });
  }
  // Components
  onComponentListControlChanged(id, name) {
    var ct = this.componentList.find(ct => ct.Id == id && ct.Name == name);
    if (ct != null) {
      ct.Selected = !ct.Selected;
    }
    this.selectedComponentsList = this.componentList.filter(c => c.Selected).map(item => {
      var comp = new ComponentVM();
      comp.Id = item.Id;
      comp.SchematicName = item.SchematicName;
      comp.SchematicId = item.SchematicId;
      comp.Name = item.Name;
      comp.MakeId = item.MakeId ? item.MakeId : 0;
      comp.PartNo = item.PartNo ? item.PartNo : "";
      comp.CusPartNo = item.CusPartNo ? item.CusPartNo : "";
      comp.Selected = item.Selected;
      comp.IsNew = item.IsNew;
      comp.SortOrder = item.SortOrder;
      comp.CompTypeId = item.CompTypeId;
      comp.IsCritical = item.IsCritical;
      comp.CompBudgetLife = item.CompBudgetLife;
      comp.isGETCritical = item.isGETCritical;
      comp.ActionId = 0;
      comp.comment = "";
      comp.cost = 0;
      comp.selectComp = false;
      comp.ActionSucess = 1;
      comp.Error = "";
      comp.ActionMinDate = null;
      comp.hasObPoint = false;
      comp.ColorCodeID = item.ColorCodeID;
      comp.MaxCrackLength = item.MaxCrackLength;
      comp.UOM = item.UOM;
      comp.severityType = item.severityType;
      comp.PartCost = 0;
      comp.MiscCost = 0;
      comp.LabourCost = 0;
      comp.LabourHrs = 0;
      comp.CompTypeSort = 1;
      comp.MakeName = "";
      comp.Planned = false;
      return comp;
    });
  }

  onComponentListFilterChange() {
    //   if (this.componentListFilter != null && this.componentListFilter.length > 0) {
    //       this.componentListFiltered = this.componentList.filter(item => item.Name != null && item.Name.toLowerCase().includes(this.componentListFilter.toLowerCase()) ? true : false)
    //   } else {
    //       this.componentListFiltered = this.componentList;
    //   }
    if (this.componentListFilter && this.componentListFilter.trim().length > 0) {
      const filterText = this.componentListFilter.toLowerCase();
      this.componentListFiltered = this.componentList.filter(item =>
        (item.Name && item.Name.toLowerCase().includes(filterText)) ||
        (item.PartNo && item.PartNo.toLowerCase().includes(filterText)) ||
        (item.MakeName && item.MakeName.toLowerCase().includes(filterText)) ||
        (item.CusPartNo && item.CusPartNo.toLowerCase().includes(filterText))
      );
    } else {
      this.componentListFiltered = this.componentList;
    }
    //   if (this.componentListFilter != null && this.componentListFilter.length > 0) {
    //     this.makeList = this.makeList.filter(item => item.Name != null && item.Name.toLowerCase().includes(this.componentListFilter.toLowerCase()) ? true : false)
    // } else {
    //     this.componentListFiltered = this.componentList;
    // }

  }

  onComponentCriticalChange(event, compId: number, Component: ComponentVM) {
    if (event.checked == true && Component.isGETCritical == true) {
      Component.isGETCritical = false
    }
    return Component.IsCritical = !Component.IsCritical;
  }

  onGETComponentCriticalChange(event, compId: number, Component: ComponentVM) {
    if (event.checked == true && Component.IsCritical == true) {
      Component.IsCritical = false
    }
    return Component.isGETCritical = !Component.isGETCritical;
  }
  //onGETComponentCriticalChange
  //add new component Type

  addNewComponentType() {
    const dialogRef = this.dialog.open(SelectionNewImplementComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        ImplementId: this.selectedImplement,
        isCompType: true,
      }
    });
    dialogRef.afterClosed().subscribe(newJobsiteName => {
      this.loadComponentTypes();
    });
  }

  addNewComponent(scrollTarget) {
    if ((this.newComponentSchematicId === undefined) || (this.newComponentSchematicId < 1)) {
      this.toastr.error(this.pageErrors.ERROR_COMPONENT_SCHEMATIC_MISSING);
      return;
    }
    if ((this.newComponentName === undefined) || (this.newComponentName.trim().length < 1)) {
      this.toastr.error(this.pageErrors.ERROR_COMPONENT_NAME_MISSING_2);
      return;
    }

    // if ((this.newComponentPartNo === undefined) || (this.newComponentPartNo.trim().length < 1)) {
    //     this.toastr.error(this.pageErrors.ERROR_COMPONENT_PART_MISSING_2);
    //     return;
    // }

    // if ((this.newComponentMakeId === undefined) || (this.newComponentMakeId == 0)) {
    //     this.toastr.error(this.pageErrors.ERROR_COMPONENT_MAKE_MISSING_2);
    //     return;
    // }
    if (this.equipmentOrInventory == '3') {
      if ((this.newComponentTypeId === undefined) || (this.newComponentMakeId == 0)) {
        this.toastr.error(this.pageErrors.ERROR_COMPONENT_TYPE_MISSING_2);
        return;
      }
    }

    if ((this.componentList != null)
      && (this.componentList.filter(cl => cl.Name != null && cl.Name.toLowerCase() == this.newComponentName.toLowerCase()).length > 0)) {
      this._snackBar.open('This component type already exists!', null, {
        duration: 1000,
      });
    } else {
      var _FilterForSchematicName = this.componentList.filter(f => f.CompTypeId == this.newComponentTypeId);
      var newComponent = new ComponentVM();
      newComponent.Id = this.newComponentId;
      newComponent.SchematicName =
        _FilterForSchematicName.length > 0
          ? _FilterForSchematicName[0].SchematicName
          : "";
      newComponent.SchematicId =
        _FilterForSchematicName.length > 0
          ? _FilterForSchematicName[0].SchematicId
          : this.newComponentSchematicId;
      newComponent.Name = this.newComponentName;
      newComponent.MakeId = this.newComponentMakeId;
      newComponent.PartNo = this.newComponentPartNo;
      newComponent.CusPartNo = this.newComponentCusPartNo;
      newComponent.Selected = true;
      newComponent.IsNew = true;
      newComponent.SortOrder = this.componentList.length;
      newComponent.CompTypeId = this.newComponentTypeId;
      newComponent.IsCritical = this.newComponentCritical;
      newComponent.CompBudgetLife = this.newcompBudgetLife;
      newComponent.isGETCritical = this.isGETCritical;
      newComponent.ActionId = 0;
      newComponent.comment = "";
      newComponent.cost = 0;
      newComponent.selectComp = false;
      newComponent.ActionSucess = 1;
      newComponent.Error = "";
      newComponent.ActionMinDate = null;
      newComponent.hasObPoint = false;
      newComponent.ColorCodeID = this.NewcolorCode;
      newComponent.MaxCrackLength = this.NewMaxCrackLength;
      newComponent.UOM = this.NewUOM;
      newComponent.severityType = this.Newseverity;
      newComponent.PartCost = 0;
      newComponent.MiscCost = 0;
      newComponent.LabourCost = 0;
      newComponent.LabourHrs = 0;
      newComponent.CompTypeSort = 99;
      newComponent.MakeName = '';
      newComponent.Planned = false;
      this.componentList.push(newComponent);
      this.componentListFilter = '';
      this.componentListFiltered = this.componentList;
      scrollTarget.scrollIntoView({ behavior: "smooth" });
      this.newComponentId++;
      this.newComponentName = '';
      this.newComponentMakeId = 0;
      this.newComponentPartNo = '';
      this.newComponentCusPartNo = '';
      this.newComponentSchematicId = 0;
      this.newComponentTypeId = 0;
      this.selectedComponentsList.push(newComponent);
      this.NewMaxCrackLength = 0;
      this.NewcolorCode = 0;
      this.Newseverity = 0;
      this.NewUOM = 1
    }
  }

  setNewComponentSchematic() {

    if (!this.newComponentTypeId) {
      this.newComponentSchematicId = 0;
      return;
    }

    // Find schematics associated with selected type
    const matchedSchematics = this.schematicList.filter(schematic => {

      if (!schematic.ComponentTypeIds) {
        return false;
      }

      const ids = schematic.ComponentTypeIds
        .split(',')
        .map((x: string) => Number(x));

      return ids.includes(Number(this.newComponentTypeId));
    });

    // Select first associated schematic
    this.newComponentSchematicId =
      matchedSchematics.length > 0
        ? matchedSchematics[0].Id
        : 0;
  }

  setNewComponentType() {

    if (!this.newComponentSchematicId) {
      this.newComponentTypeId = 0;
      return;
    }

    const schematic = this.schematicList.find(s =>
      Number(s.Id) === Number(this.newComponentSchematicId)
    );

    if (!schematic || !schematic.ComponentTypeIds) {
      this.newComponentTypeId = 0;
      return;
    }

    const ids = schematic.ComponentTypeIds
      .split(',')
      .map((x: string) => Number(x));

    const matchedTypes = this.componentTypeList.filter(type =>
      ids.includes(Number(type.Id))
    );

    this.newComponentTypeId =
      matchedTypes.length > 0
        ? matchedTypes[0].Id
        : 0;
  }

  getFilteredComponentTypes(schematicId: number) {
    const schematic = this.schematicList.find(x => x.Id === schematicId);
    if (!schematic || !schematic.ComponentTypeIds) {
      return this.componentTypeList;
    }
    const allowedIds = schematic.ComponentTypeIds.split(',').map((x: string) => Number(x));
    return this.componentTypeList.filter(type =>allowedIds.includes(type.Id)
    );
  }

  getComponentTypeDisplay(type: any): string {

    if (!this.newComponentSchematicId ||
      this.newComponentSchematicId == 0) {
      return type.Name;
    }

    const isAssociated =
      this.isComponentTypeAssociated(type.Id);

    const isSelected =
      Number(this.newComponentTypeId) === Number(type.Id);

    return (isAssociated && !isSelected)
      ? '➜ ' + type.Name
      : type.Name;
  }

  getSchematicDisplay(sch: any): string {

    if (!this.newComponentTypeId ||
      this.newComponentTypeId == 0) {
      return sch.ImageName;
    }

    const isAssociated =
      this.isSchematicAssociated(sch);

    const isSelected =
      Number(this.newComponentSchematicId) === Number(sch.Id);

    return (isAssociated && !isSelected)
      ? '➜ ' + sch.ImageName
      : sch.ImageName;
  }

  deleteNewComponent(id) {
    console.log("id__", id, this.componentList)
    this.componentList = this.componentList.filter(f => !(f.Id == id && f.IsNew == true));
    this.selectedComponentsList = this.selectedComponentsList.filter(f => !(f.Id == id && f.IsNew == true));
    this.initialiseSortOrder();
    this.componentListFiltered = this.componentList;
  }

  deleteOldComponent(comp: ComponentVM) {
    this.componentList = this.componentList.filter(f => !(f.Id == comp.Id));
    this.selectedComponentsList = this.selectedComponentsList.filter(f => !(f.Id == comp.Id));
    this.componentListFiltered = this.componentList;
    let arra_ = []
    arra_.push(comp);
    var params: SaveComponentParams = new SaveComponentParams();
    params.ImplementId = this.attachedImplementSelected;
    params.Components = arra_;
    this._implementService.DeleteComponents(params).subscribe(res => {
      if (res == true) {
        this.initialiseSortOrder();
      }
    })
  }

  initialiseSortOrder() {
    console.log("before this.componentList:", this.componentList);
    for (var i = 0; i < this.componentList.length; i++) {
      this.componentList[i].SortOrder = i;
    }
    console.log("after this.componentList:", this.componentList);
  }

  recalculateSortOrder(id, isDown, isNew) {
    for (var i = 0; i < this.componentList.length; i++) {
      // Not the entry that was clicked upon.
      if (this.componentList[i].Id != id) {
        continue;
      }
      // Found the item that was selected.
      else {
        // First item and sort position decreased.
        if ((i == 0) && !isDown) {
          // DO NOTHING
          //this.componentList[i].SortOrder = 0;
        }
        // Last item and sort position increased.
        else if ((i == this.componentList.length - 1) && isDown) {
          // DO NOTHING
          //this.componentList[i].SortOrder = this.componentList.length - 1;
        }
        // Increase sort position
        else if ((i >= 0) && isDown && (i < this.componentList.length - 1)) {
          var pos = this.componentList[i + 1].SortOrder;
          this.componentList[i + 1].SortOrder = this.componentList[i].SortOrder;
          this.componentList[i].SortOrder = pos;
          var CompTypePos = this.componentList[i + 1].CompTypeSort;
          this.componentList[i + 1].CompTypeSort = this.componentList[i].CompTypeSort;
          this.componentList[i].CompTypeSort = CompTypePos;
        }
        // Decrease sort position
        else if ((i < this.componentList.length) && !isDown && (i > 0)) {
          var pos = this.componentList[i - 1].SortOrder;
          this.componentList[i - 1].SortOrder = this.componentList[i].SortOrder;
          this.componentList[i].SortOrder = pos;

          var CompTypePos = this.componentList[i - 1].CompTypeSort;
          this.componentList[i - 1].CompTypeSort = this.componentList[i].CompTypeSort;
          this.componentList[i].CompTypeSort = CompTypePos;
        }
      }
    }
    this.componentList.sort((s, t) => {
      if (s.SortOrder > t.SortOrder) {
        return 1;
      }
      if (s.SortOrder < t.SortOrder) {
        return -1;
      }

      return 0;
    });
    this.onComponentListFilterChange();
  }

  isFirstComponentInList(id, CompTypeId) {
    if (this.componentList.find(f => f.Id == id && f.CompTypeId == CompTypeId).CompTypeSort == 1) {
      return false;
    }
    return true;
  }

  isLastComponentInList(id, CompTypeId) {
    // Find all components that match the criteria
    let getallComp = this.componentList.filter(f => f.CompTypeId == CompTypeId);
    // Check if the array is not empty and if the length matches the condition
    if (getallComp.length > 0) {
      // Assuming CompTypeSort should match the array length minus one
      if (getallComp.find(x => x.Id == id).CompTypeSort == getallComp.length) {
        return false;
      }
    }
    return true;
  }

  isFirstSchematicInList(id: number): boolean {
    return this.schematicList?.length ? this.schematicList[0].Id === id : false;
  }
  isLastSchematicInList(id: number): boolean {
    return this.schematicList?.length ? this.schematicList[this.schematicList.length - 1].Id === id : false;
  }

  recalculateSortOrderSchematic(id, isDown, isNew) {
    for (var i = 0; i < this.schematicList.length; i++) {
      // Not the entry that was clicked upon.
      if (this.schematicList[i].Id != id) {
        continue;
      }
      // Found the item that was selected.
      else {
        // First item and sort position decreased.
        if ((i == 0) && !isDown) {
          // DO NOTHING
          //this.componentList[i].SortOrder = 0;
        }
        // Last item and sort position increased.
        else if ((i == this.schematicList.length - 1) && isDown) {
          // DO NOTHING
          //this.componentList[i].SortOrder = this.componentList.length - 1;
        }
        // Increase sort position
        else if ((i >= 0) && isDown && (i < this.schematicList.length - 1)) {
          var pos = this.schematicList[i + 1].SortOrder;
          this.schematicList[i + 1].SortOrder = this.schematicList[i].SortOrder;
          this.schematicList[i].SortOrder = pos;
        }
        // Decrease sort position
        else if ((i < this.schematicList.length) && !isDown && (i > 0)) {
          var pos = this.schematicList[i - 1].SortOrder;
          this.schematicList[i - 1].SortOrder = this.schematicList[i].SortOrder;
          this.schematicList[i].SortOrder = pos;
        }
      }
    }
    this.saveSchemanticImages();
    //this.loadGETComponents();
    this.schematicList.sort((s, t) => {
      if (s.SortOrder > t.SortOrder) {
        return 1;
      }
      if (s.SortOrder < t.SortOrder) {
        return -1;
      }

      return 0;
    });
    //this.onComponentListFilterChange();
  }

  getMakeById(id) {
    if (this.makeList != null && this.makeList.length > 0) {
      var makeDesc = this.makeList.find(w => w.Id == id);
      if (makeDesc != null) {
        return makeDesc.Name;
      }
      return "";
    }
    return "";
  }

  // Toggle filters
  toggleSelectedModels() {
    this.hideSelectedModels = !this.hideSelectedModels;
  }

  toggleUnselectedModels() {
    this.hideUnselectedModels = !this.hideUnselectedModels;
  }

  toggleAllComponents(v) {
    this.componentList.forEach(c => c.Selected = v);
    this.componentListFiltered.forEach(c2 => c2.Selected = v);
  }
  toggleShowHideSchOrder() {
    this.ShowHideSchOrder = !this.ShowHideSchOrder;
  }

  toggleSelectedMPs() {
    this.hideSelectedMPs = !this.hideSelectedMPs;
  }

  toggleUnselectedMPs() {
    this.hideUnselectedMPs = !this.hideUnselectedMPs;
  }

  toggleSelectedOPs() {
    this.hideSelectedOPs = !this.hideSelectedOPs;
  }

  toggleUnselectedOPs() {
    this.hideUnselectedOPs = !this.hideUnselectedOPs;
  }

  toggleAllObsevations(v) {
    this.observationPoints.forEach(c => c.Selected = v);
    this.observationListFiltered.forEach(c2 => c2.Selected = v);
  }

  selectionLogicForModels(isSelected: boolean): boolean {
    if ((!this.hideSelectedModels && !this.hideUnselectedModels)
      || (!this.hideSelectedModels && isSelected && this.hideUnselectedModels)
      || (!this.hideUnselectedModels && !isSelected && this.hideSelectedModels)) {
      return true;
    } else {
      return false;
    }
  }

  selectionLogicForMPs(isSelected: boolean): boolean {
    if ((!this.hideSelectedMPs && !this.hideUnselectedMPs)
      || (!this.hideSelectedMPs && isSelected && this.hideUnselectedMPs)
      || (!this.hideUnselectedMPs && !isSelected && this.hideSelectedMPs)) {
      return true;
    } else {
      return false;
    }
  }

  selectionLogicForOPs(isSelected: boolean): boolean {
    if ((!this.hideSelectedOPs && !this.hideUnselectedOPs)
      || (!this.hideSelectedOPs && isSelected && this.hideUnselectedOPs)
      || (!this.hideUnselectedOPs && !isSelected && this.hideSelectedOPs)) {
      return true;
    } else {
      return false;
    }
  }

  preLoadComponentTypesSelected() {
    // Component type list
    if (this.implementTemplateDetails.ComponentTypes != null) {

      for (var i = 0; i < this.implementTemplateDetails.ComponentTypes.length; i++) {
        // Add to the list of selected component types
        var newImplementComponentType = new ComponentVM();
        newImplementComponentType.Id = this.implementTemplateDetails.ComponentTypes[i].Id;
        newImplementComponentType.Name = this.implementTemplateDetails.ComponentTypes[i].Name;
        newImplementComponentType.Selected = true;
        this.selectedComponentsList.push(newImplementComponentType);

        // Mark the selected components in the filtered list.
        for (var j = 0; j < this.componentListFiltered.length; j++) {
          if (this.componentListFiltered[j].Id == this.implementTemplateDetails.ComponentTypes[i].Id) {
            this.componentListFiltered[j].Selected = true;
            break;
          }
        }
      }
    }
  }


  OldObservationPoints: ObservationPointDetails[];
  loadOLDObservationPointsForImplement() {
    this._subscriptions.push(this._implementService.GetObservationPointDetails(this.selectedImplement).subscribe(r => {
      this.OldObservationPoints = r;
    }));
  }
  OldComponentList: ComponentVM[];
  loadOldGETComponents() {
    this._implementService.ReturnGETComponents(this.selectedImplement).subscribe(result => {
      this.OldComponentList = result;
    });
  }


  loadGETComponents() {
    this._implementService.ReturnGETComponents(this.selectedImplement).subscribe(result => {
      this.componentList = result;
      this.OldComponentList = result;
      this.componentListFiltered = result;
      this.selectedComponentsList = [];
      this.NewUOM = this.componentListFiltered[0].UOM;
      //this.preLoadComponentsSelected();
      this.initialiseSortOrder();

    });
  }

  loradtarget: GenericIdName[] = [];
  // Implement Makes
  loadMakes() {
    this._subscriptions.push(this._implementService.GetImplementMakes().subscribe(r => {
      this.makeList = r;
      this.filtermakeList = r;
    }));
  }

  //Component Type For Implements
  loadComponentTypes() {
    this._subscriptions.push(this._implementService.GetComponentTypesForImplement(this.selectedImplement).subscribe(r => {
      this.componentTypeList = r;
    }));
  }

  //save schmenatic images    
  saveSchemanticImages() {
    // Now save schematic images.
    this.SelectedschematicImageList.ImplementID = this.selectedImplement;
    this.SelectedschematicImageList.SchematicImageList = [];
    this.schematicList.forEach(s => {
      var newSchematic: SchematicUploadParams = new SchematicUploadParams();
      newSchematic.ImageName = s.ImageName;
      newSchematic.ImageData = s.Data;
      newSchematic.IsNewImage = s.IsNewImage;
      newSchematic.SortOrder = s.SortOrder;
      newSchematic.Id = s.Id;
      //if (s.IsNewImage)
      this.SelectedschematicImageList.SchematicImageList.push(newSchematic);
    });
    //this.SelectedschematicImageList.ImplementID = this.selectedImplement;
    this._implementService.SaveSchematicImageList(this.SelectedschematicImageList).subscribe(r => {
      //this.saveComponents();
      this.toastr.success("Schematics Changes Saved successfully.");
      this.loadImplementSchematics();
    });
  }

  showSchematicImageName(componentId: number) {
    var _FilterForSchematicName = this.OldComponentList.filter(f => f.Id == componentId);
    //console.log("_FilterForSchematicName:", _FilterForSchematicName);
    if (_FilterForSchematicName != null && _FilterForSchematicName[0].SchematicName != null && _FilterForSchematicName[0].SchematicName != "")
      return true;
    else
      return false;
  }

  getImage(image: string) {
    // return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);

  }

  getPosition(posX: string, posY: string) {
    var iPX = (parseFloat(posX));// / 640.0) * this.pageConstants.THUMBNAIL_WIDTH;
    var iPY = (parseFloat(posY)); // 520.0) * this.pageConstants.THUMBNAIL_HEIGHT;
    return this._sanitizer.bypassSecurityTrustStyle('Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;' + 'Position: absolute;');
  }

  getEval(wornPct: number, inspectDate: string) {
    if ((wornPct == 0) && (inspectDate == "Never")) {
      return 'gray';
    } else if (wornPct <= 30) {
      return 'green';
    } else if ((wornPct > 30) && (wornPct <= 60)) {
      return 'yellow';
    } else if ((wornPct > 60) && (wornPct <= 80)) {
      return 'orange';
    } else if (wornPct > 80) {
      return 'red';
    }
  }

  loadImplementImage() {
    this._subscriptions.push(this._implementService.LoadImplementImage(this.selectedImplement).subscribe(r => {
      this.implementImage = r;
    }));
  }

  // Implement photo upload
  onSelectImplementPhoto(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const reader = new FileReader();

      reader.readAsDataURL(file); // read file as data URL

      reader.onload = (e: ProgressEvent<FileReader>) => {
        if (e.target?.result) {
          const imageUrl = e.target.result as string;
          if (this.selectedImplement > 0) {
            this.saveImplementImage(imageUrl);
          } else {
            this.isNewImplement = true;
            this.NewImplementImage = imageUrl;

            // Clean up the base64 string to extract the image data
            let sImageUrl = imageUrl.replace(/^data:image\/[a-z]+;base64,/, "");
            sImageUrl = sImageUrl.replace(/^data:image\/\w+;base64,/, "");
            this.implementImage = sImageUrl;
          }

          // Clear the file input
          this.ImplementImageUpload.nativeElement.value = '';
        }
      };

      reader.onerror = (error) => {
        console.error('Error reading file:', error);
      };
    }
  }

//   getUOM() {
//     this.userPrefrence.getUserPreferences().subscribe(res => {
//         this.UOM = res.UnitOfMeasurementName === 'mm' ? 1 : 2; // Convert "mm" to 1, "inches" to 2
//       // this.componentListFiltered.
//     });
// }

  //  // Schematic photo upload
  //  onSelectSchematicPhoto(event) {
  //   if (event.target.files && event.target.files[0]) {
  //       var reader = new FileReader();

  //       reader.readAsDataURL(event.target.files[0]); // read file as data url
  //       this.selectedSechamnticImage = event.target.files[0]
  //       reader.onload = (event: FileReaderEvent) => { // called once readAsDataURL is completed


  //         var imageUrl = (event.target.result);

  //           //resize photo
  //           this.compressImage(imageUrl).then((res: string) => {
  //               if (res) {
  //                   this.saveSchematicImage(res, this.selectedSechamnticImage);
  //               }
  //           })

  //           this.SchematicImageUpload.nativeElement.value = '';
  //       }
  //   }
  // }

  // Schematic photo upload
  // onSelectSchematicPhoto(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   if (input.files && input.files[0]) {
  //     const file = input.files[0];
  //     const reader = new FileReader();

  //     reader.readAsDataURL(file); // Read file as data URL

  //     reader.onload = (e: ProgressEvent<FileReader>) => {
  //       if (e.target?.result) {
  //         const imageUrl = e.target.result as string;

  //         // Resize photo
  //         this.compressImage(imageUrl).then((res: string) => {
  //           if (res) {
  //             this.saveSchematicImage(res, file);
  //           }
  //         }).catch((error) => {
  //           console.error('Error compressing image:', error);
  //         });

  //         // Clear the file input
  //         this.SchematicImageUpload.nativeElement.value = '';
  //       }
  //     };

  //     reader.onerror = (error) => {
  //       console.error('Error reading file:', error);
  //     };
  //   }
  // }



// onSelectSchematicPhoto(event: Event): void {
//   this.loading = true;
//   const input = event.target as HTMLInputElement;
//   if (input.files && input.files[0]) {
//     let file = input.files[0];
//     const isHeic =
//       file.type === "image/heic" ||
//       file.name.toLowerCase().endsWith(".heic");
//     const processFile = (f: File) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(f);
//       reader.onload = (e: ProgressEvent<FileReader>) => {
//         if (e.target?.result) {
//           const imageUrl = e.target.result as string;
//           this.compressImage(imageUrl)
//             .then((res: string) => {
//               if (res) {
//                 this.saveSchematicImage(res, f);
//               }
//             })
//           // clear input
//           this.SchematicImageUpload.nativeElement.value = '';
//         }
//       };
//     };
//     if (isHeic) {
//       (heic2any as any).default({
//         blob: file,
//         toType: "image/jpeg",
//         quality: 0.8
//       })
//       .then((result: any) => {
//         const convertedBlob = Array.isArray(result) ? result[0] : result;
//         const convertedFile = new File([convertedBlob], "converted.jpg", {
//           type: "image/jpeg"
//         });
//         processFile(convertedFile);
//       })
//       .catch((err: any) => {
//         console.error("HEIC conversion failed", err);
//         this.toastr.error("Failed to convert HEIC image. Please try a different image.");
//       });
//     } else {
//       processFile(file);
//     }
//   }
// }

async onSelectSchematicPhoto(event: Event): Promise<void> {

  this.loading = true;

  const input = event.target as HTMLInputElement;

  if (!(input.files && input.files[0])) {
    return;
  }

  const file = input.files[0];

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {

    const reader = new FileReader();

    reader.onload = (e: ProgressEvent<FileReader>) => {

      if (e.target?.result) {

        const imageUrl = e.target.result as string;

        this.compressImage(imageUrl)
          .then((res: string) => {

            if (res) {
              this.saveSchematicImage(res, f);
            }

          })
          .catch(err => {
            console.error(err);
            this.loading = false;
          });

        // Clear input
        this.SchematicImageUpload.nativeElement.value = '';

      }

    };

    reader.readAsDataURL(f);

  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg",   // Use "toType" if required by your heic-to version
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    this.loading = false;

    console.error("HEIC conversion failed", err);

    this.toastr.error(
      "Failed to convert HEIC image. Please try a different image."
    );

    this.SchematicImageUpload.nativeElement.value = '';

  }

}
  compressImage(src: any) {
    return new Promise((res, rej) => {
      const img = new Image();

      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');

        let width, height;
        width = img.width;
        height = img.height;

        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        var new_height = imageWidth * ratio; //calculate new height


        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }


  // Save the implement image.
  saveImplementImage(imageUrl: string) {
    var saveParams: SaveImplementImageParams = new SaveImplementImageParams();
    saveParams.GETAuto = this.selectedImplement;
    saveParams.ImageData = imageUrl;
    this._subscriptions.push(this._implementService.SaveImplementImage(saveParams).subscribe(r => {
      if (r) {
        this.loadImplementImage();
      }
    }));
  }

  //remove implement image
  deleteImplementImage() {
    var saveParams: SaveImplementImageParams = new SaveImplementImageParams();
    saveParams.GETAuto = this.selectedImplement;
    this._subscriptions.push(this._implementService.DeleteImplementImage(saveParams).subscribe(r => {
      if (r) {
        this.toastr.success("Deleted successfully");
        this.implementImage = null;
        this.NewImplementImage = null;
      }
    }));

  }
  // Save the schematic image temporarily.
  saveSchematicImage(imageUrl: string, imageName: File) {
    var sImageUrl = imageUrl.replace(/^data:image\/[a-z]+;base64,/, "");
    sImageUrl = sImageUrl.replace(/^data:image\/\w+;base64,/, "");
    this.schematicList.push({
      Id: this.NewSchematicId,
      Data: sImageUrl,
      ImageName: imageName.name,
      ObservationPoints: [],
      IsNewImage: true,
      SortOrder: this.schematicList.length,
      OBSCount: 0,
      InactiveOBSCount: 0,
      ComponentTypeIds: '',
      IsHidden: false
    });
    //this.NewSchematicId++;
    this.saveSchemanticImages();
  }


  // Load the schematics, components (aka measurement points) and
  // observation points on Tab 3.
  loadComponentsAndObservationPoints() {
    //this.loadComponentsForImplement();
    this.loadObservationPointsForImplement();
    this.loadImplementSchematics();
  }

  // Load the observation lists for the selected customer.
  loadObservationLists() {
    this._subscriptions.push(this._implementService.GetObservationLists(this.selectedCustomer, this.selectedImplement).subscribe(r => {
      this.observationLists = r;

    }));
  }

  // Load the Observation Point types.
  loadObservationPointTypes() {
    this._subscriptions.push(this._implementService.GetObservationPointTypes().subscribe(r => {
      this.observationPointTypes = r;

      //this.observationPointTypes =  r.filter(x=>x.Id != 3)
    }));
  }

  // Load the Observation Points for the selected GET and implement type.
  loadObservationPointsForImplement() {
    this._subscriptions.push(this._implementService.GetObservationPointDetails(this.selectedImplement).subscribe(r => {
      this.observationPoints = r;
      this.observationListFiltered = r;
      // this.observationListFiltered.map(x=>{
      //     if(x.ObservationPointType == 3){
      //         x.NumberOfReadings =null;
      //         x.LimitNew=null;
      //         x.LimitScrap=null;
      //     }
      // })
      this.observationListAfterChanages = r;
    }));
  }

  // Load the Implement Schematics.
  loadImplementSchematics() {
    this.loading = true;
    // Fix issue where selectedImplement resets to 0 on navigating away.
    var implementId = this.selectedImplement;
    if ((implementId == 0) && (!isNaN(this.attachedImplementSelected))) {
      implementId = this.attachedImplementSelected;
    }
    //console.log("implementId", implementId)
    this._subscriptions.push(this._implementService.GetSchematicData(implementId).subscribe(r => {
      this.schematicList = r;
      this.loading = false;
      console.log("schematicList", this.schematicList);
    }));
  }





  checkOkToCopy(): ValidationErrorStatus {
    var result: ValidationErrorStatus = {
      Status: false,
      Message: ""
    };

    let valid_customer = this.selectedCustomer > 0 ? true : false;
    let valid_jobsite = this.selectedJobsite > 0 ? true : false;
    let valid_equipment = this.selectedEquipment > 0 ? true : false;

    if (this.equipmentOrInventory == this.pageConstants.SETUP_ON_EQUIPMENT) {
      if (valid_customer && valid_jobsite && valid_equipment) {
        result.Status = true;
      } else {
        result.Status = false;
        result.Message = "Please enter customer, jobsite and equipment.";
      }
    } else if (this.equipmentOrInventory == this.pageConstants.SETUP_IN_INVENTORY) {
      if (valid_customer && valid_jobsite) {
        result.Status = true;
      } else {
        result.Status = false;
        result.Message = "Please enter customer and jobsite.";
      }
    } else {
      result.Status = false;
      result.Message = "Please select either Equipment or Jobsite Inventory.";
    }

    return result;
  }

  copyImplementFromExisting() {
    var OkToCopy = this.checkOkToCopy();
    if (!OkToCopy.Status) {
      this.toastr.error(OkToCopy.Message);
    } else {
      let copyImplementModalRef = this.dialog.open(CopyImplementDialogComponent, {
        width: '1024px',
        height: '780px',
        data: {
          equipmentId: this.selectedEquipment,
          jobsiteId: this.selectedJobsite,
          //isClose:false
        }
      });
      copyImplementModalRef.afterClosed().subscribe(r => {
        if (r.data != null) {
          // if(r.data.isClose==true)
          // {
          //     this._subscriptions.push(this._implementService.GetTemplateListForUser().subscribe(r => {
          //         this.implementTypeList = r;
          //     }));
          // }
        } else {

        }
      });
    }
  }

  resetSelectType(e) {
    this.selectedImplementType = 0
  }
  TypeSelect: boolean = false


  showDeleteConfirmationDialog() {
    let confirmationModalRef = this.dialog.open(GETDeleteConfirmationDialogComponent, {
      width: '480px',
      height: '280px'
    });
    confirmationModalRef.afterClosed().subscribe(r => {
      if ((r.data != null) && (r.data.goAhead)) {

        // Confirm delete
        this.prevSelectedImplementType = this.selectedImplementType;
        this._implementService.DeleteImplement(this.attachedImplementSelected).subscribe(r2 => {
          if (r2) {
            this.toastr.info(this.pageConstants.INFO_IMPLEMENT_DELETED);
            this.attachedImplementSelected = 0;
            this.selectedImplement = 0;
          } else {
            this.toastr.error(this.pageErrors.ERROR_SAVING_CHANGES);
          }
        });
      } else {
        // Don't delete
        this.selectedImplementType = this.prevSelectedImplementType;
      }
    });
  }

  onNumReadingsEntered(OP, e) {

    if (e.target.value < 0) {
      OP.NumReadings = 0;
      this.toastr.error("Please enter a value between 0 - 5 for the readings");
      // this.isvalidStep3 = false
    } else if (e.target.value > 5) {
      OP.NumReadings = 5;
      this.toastr.error("Please enter a value between 0 - 5 for the readings")
      //this.isvalidStep3 = false

    } else {
      OP.NumReadings = parseInt(e.target.value.toString().replace('+', '').replace('-', ''))

    }

    //OP.NumReadings = parseInt(e.target.value.toString().replace('+', '').replace('-', ''))
  }

  onLimitsEntered(OP, e) {
    if (e.target.value > 0) {
      if (OP.NumReadings == 0) {
        this.toastr.error("Can not enter Limits, unless you have specified No of reading");
        e.target.value = 0;
      }
    }

  }
  onNewOPLimitNewEntered(e) {
    this.newOPLimitNew = e.target.value;
  }

  onNewOPLimitScrapEntered(e) {
    this.newOPLimitScrap = e.target.value;
  }

  onPartNumberChanged(MP, e) {
    MP.PartNo = e.target.value;
  }

  // Handle the right-click 'select and copy' context menu.
  // e: the right-click context menu event.
  // isMP: if true then it is for measurement point, otherwise an observation point.
  // id: the Id of the measurement point or observation point in the row selected.
  // category: whether this is the make, observation list, initial length or worn length.
  // val: the value to be copied across.
  displayContextMenu(e, isMP, id, category) {
    this.showContextMenu = true;
    this.contextMenuY = e.pageY + 'px';
    this.contextMenuX = e.pageX + 'px';


    this.selectionData.Id = id;
    this.selectionData.Category = category;
    if (category == "ObservationList") {
      this.selectionData.Val = isMP
      this.selectionData.IsMP = false;
    }
    else {
      this.selectionData.Val = e.target.value;
      this.selectionData.IsMP = isMP;
    }

    this.clearHighlights();
  }

  // Hide the context menu.
  hideContextMenu(e) {
    this.showContextMenu = false;
  }

  // Clear the highlight for previously updated cells.
  clearHighlights() {
    this.showAllCells = false;
    this.showVacantCells = false;
  }

  // Copy the selection data to all cells for the category. (canOverwrite=true)
  copySelectionToAll(e) {
    this.copySelection(e, true);
  }

  // Copy the selection data only to the vacant cells for the category. (canOverwrite=false)
  copySelectionToVacant(e) {
    this.copySelection(e, false);
  }

  // Handles the main logic for copying selected data to all cells for the category.
  copySelection(e, canOverwrite) {
    if (this.selectionData != null) {
      // Handle Measurement Points
      if (this.selectionData.IsMP) {

        for (var i = 0; i < this.componentList.length; i++) {
          this.updateDataBasedOnCategory(this.componentList, i, canOverwrite);
        }
      }

      // Handle Observation Points
      else {
        for (var i = 0; i < this.observationPoints.length; i++) {
          this.updateDataBasedOnCategory(this.observationPoints, i, canOverwrite);
        }
      }
    }
  }

  // Handles the assignment logic for each category.
  updateDataBasedOnCategory(src, index, canOverwrite) {

    if (this.selectionIsMake()) {
      if ((src[index].Make == 0) || (canOverwrite)) {
        src[index].Make = this.selectionData.Val;
      }
    } else if (this.selectionIsObservationList()) {
      if ((src[index].ObservationListIds == 0) || (canOverwrite)) {
        src[index].ObservationListIds = this.selectionData.Val;
      }
    } else if (this.selectionIsLimitNew()) {
      if (this.checkIfVacant(this.pageConstants.COL_INITIAL_LENGTH, src[index].LimitNew, src[index].LimitScrap) || (canOverwrite)) {
        src[index].LimitNew = this.selectionData.Val;
      }
    } else if (this.selectionIsLimitScrap()) {
      if (this.checkIfVacant(this.pageConstants.COL_WORN_LENGTH, src[index].LimitNew, src[index].LimitScrap) || (canOverwrite)) {
        src[index].LimitScrap = this.selectionData.Val;
      }
    } else if (this.selectionIsPartNo()) {
      if (this.checkIfVacant(this.pageConstants.COL_PART_NO, src[index].PartNo, null) || (canOverwrite)) {
        src[index].PartNo = this.selectionData.Val;
      }
    } else if (this.selectionIsNumberOfReadings()) {
      if (this.checkIfVacant(this.pageConstants.COL_NUM_READINGS, src[index].NumberOfReadings, null) || (canOverwrite)) {
        src[index].NumberOfReadings = this.selectionData.Val;
      }
    } else if (this.selectionIsObservationPointType()) {
      if ((src[index].ObservationPointType == 0) || (canOverwrite)) {
        src[index].ObservationPointType = this.selectionData.Val;
      }
    } else if (this.selectionIsObservationPointName()) {
      if (this.checkIfVacant(this.pageConstants.COL_OP_NAME, src[index].Name, null) || (canOverwrite)) {
        src[index].Name = this.selectionData.Val;
      }
    } else if (this.selectionIsObservationPointQName()) {
      if (this.checkIfVacant(this.pageConstants.COL_OP_Q_NAME, src[index].QName, null) || (canOverwrite)) {
        src[index].QName = this.selectionData.Val;
      }
    } else if (this.selectionIsObservationPointQDesc()) {
      if (this.checkIfVacant(this.pageConstants.COL_OP_Q_DESC, src[index].QDesc, null) || (canOverwrite)) {
        src[index].QDesc = this.selectionData.Val;
      }
    }
  }

  // Returns true if the selected cell is for 'Make'.
  selectionIsMake() {
    if (this.selectionData.Category == this.pageConstants.COL_MAKE) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Observation List'.
  selectionIsObservationList() {
    if (this.selectionData.Category == this.pageConstants.COL_OBSERVATION_LIST) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Initial Length'.
  selectionIsLimitNew() {
    if (this.selectionData.Category == this.pageConstants.COL_INITIAL_LENGTH) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Worn Length'.
  selectionIsLimitScrap() {
    if (this.selectionData.Category == this.pageConstants.COL_WORN_LENGTH) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Part No'.
  selectionIsPartNo() {
    if (this.selectionData.Category == this.pageConstants.COL_PART_NO) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Number Of Readings'.
  selectionIsNumberOfReadings() {
    if (this.selectionData.Category == this.pageConstants.COL_NUM_READINGS) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Observation Point Type'.
  selectionIsObservationPointType() {
    if (this.selectionData.Category == this.pageConstants.COL_OP_TYPE) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Observation Point Name'.
  selectionIsObservationPointName() {
    if (this.selectionData.Category == this.pageConstants.COL_OP_NAME) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Observation Point Name'.
  selectionIsObservationPointQName() {
    if (this.selectionData.Category == this.pageConstants.COL_OP_Q_NAME) {
      return true;
    }
    return false;
  }

  // Returns true if the selected cell is for 'Observation Point Name'.
  selectionIsObservationPointQDesc() {
    if (this.selectionData.Category == this.pageConstants.COL_OP_Q_DESC) {
      return true;
    }
    return false;
  }

  selectionIsObservationPointLimitRange() {
    if (this.selectionData.Category == this.pageConstants.COL_OP_LIMITRANGE) {
      return true;
    }
    return false;
  }

  selectionIsObservationPointMeasurement() {
    if (this.selectionData.Category == this.pageConstants.COL_OP_MEASUREMENT) {
      return true;
    }
    return false;
  }
  // Check if the cell is vacant.
  // The Make and Observation List cells are vacant if the first entry is selected.
  // Initial and Worn lengths are considered blank if both those cells are 0,
  // or if one of those cells is empty.
  // Part number and Number of Readings are vacant if the cell contains no valid characters or is null.
  checkIfVacant(cat, val1, val2) {
    if (cat == this.pageConstants.COL_MAKE || cat == this.pageConstants.COL_OBSERVATION_LIST || cat == this.pageConstants.COL_OP_TYPE) {
      if (val1 == 0) {
        return true;
      }
    }

    else if (cat == this.pageConstants.COL_INITIAL_LENGTH || cat == this.pageConstants.COL_WORN_LENGTH) {
      if (cat == this.pageConstants.COL_INITIAL_LENGTH && (val1 == "" || val1 == null)) {
        return true;
      }
      else if (cat == this.pageConstants.COL_WORN_LENGTH && (val2 == "" || val2 == null)) {
        return true;
      }
      else if (val1 == 0 && val2 == 0) {
        return true;
      }
    }

    else if ((cat == this.pageConstants.COL_PART_NO) || (cat == this.pageConstants.COL_NUM_READINGS) || (cat == this.pageConstants.COL_OP_NAME) || (cat == this.pageConstants.COL_OP_Q_NAME) || (cat == this.pageConstants.COL_OP_Q_DESC)) {
      if (val1 == "" || val1 == null) {
        return true;
      }
    }

    return false;
  }

  // Enable or Disable highlighting for selected vacant cells.
  toggleVacantCells(status) {
    this.showVacantCells = status;
  }

  // Enable or Disable highlighting for all selected cells.
  toggleAllCells(status) {
    this.showAllCells = status;
  }

  //////////////////////////////////////////////
  // Helper functions for CSS Highlight logic //
  //////////////////////////////////////////////

  highlightCopyImplementIcon() {
    this.mouseoverITReplicate = !this.mouseoverITReplicate;
  }

  highlightMake(val) {
    if ((this.showAllCells) || (this.showVacantCells && val == 0)) {
      if (this.selectionIsMake() && this.selectionData.IsMP) {
        return true;
      }
    }
    return false;
  }

  highlightObservationList(val) {
    if ((this.showAllCells) || (this.showVacantCells && val == 0)) {
      if (this.selectionIsObservationList()) {
        return 2;
      }
    }
    return 0;
  }

  highlightLimitNew(il, wl) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_INITIAL_LENGTH, il, wl))) {
      if (this.selectionIsLimitNew()) {
        if (this.selectionData.IsMP) {
          return 1;
        } else {
          return 2;
        }
      }
    }
    return 0;
  }

  highlightLimitScrap(il, wl) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_WORN_LENGTH, il, wl))) {
      if (this.selectionIsLimitScrap()) {
        if (this.selectionData.IsMP) {
          return 1;
        } else {
          return 2;
        }
      }
    }
    return 0;
  }

  highlightPartNo(val) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_PART_NO, val, null))) {
      if (this.selectionIsPartNo() && this.selectionData.IsMP) {
        return true;
      }
    }
    return false;
  }

  highlightNumberOfReadings(val) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_NUM_READINGS, val, null))) {
      if (this.selectionIsNumberOfReadings()) {
        return true;
      }
    }
    return false;
  }

  highlightName(val) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_NAME, val, null))) {
      if (this.selectionIsObservationPointName()) {
        return true;
      }
    }
    return false;
  }

  highlightQName(val) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_Q_NAME, val, null))) {
      if (this.selectionIsObservationPointQName()) {
        return true;
      }
    }
    return false;
  }
  highlightQDesc(val) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_Q_DESC, val, null))) {
      if (this.selectionIsObservationPointQDesc()) {
        return true;
      }
    }
    return false;
  }

  highlightLimitRange(val) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_LIMITRANGE, val, null))) {
      if (this.selectionIsObservationPointLimitRange()) {
        return true;
      }
    }
    return false;
  }

  highlightMeasurement(val) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_MEASUREMENT, val, null))) {
      if (this.selectionIsObservationPointMeasurement()) {
        return true;
      }
    }
    return false;
  }

  highlightType(val) {
    if ((this.showAllCells) || (this.showVacantCells && this.checkIfVacant(this.pageConstants.COL_OP_TYPE, val, null))) {
      if (this.selectionIsObservationPointType()) {
        return true;
      }
    }
    return false;
  }

  /////////////////////////////
  // Handle Schematic Window //
  /////////////////////////////

  openEnlargedImage(iImage, imgOrSchematic) {
    var img1: SchematicDataVM = new SchematicDataVM();
    img1.Id = 0;
    img1.ObservationPoints = null;
    img1.Data = iImage;

    this.openSchematicWindow(img1, imgOrSchematic);
  }

  isTemplate: boolean = false;

  openSchematicWindow(schematic, imgOrSchematic) {
    //this.isTemplate = this.equipmentOrInventory == '3' ? true : false;
    //this.schematicPositionX = 500;
    //this.schematicPositionY = 160;
    //this.prevMouseX = 0;
    //this.prevMouseY = 0;
    //this.selectedSchematic = schematic;
    //this.showSchematic = true;
    //if (imgOrSchematic == 1) {
    //  this.draggableSchematicTitle = "Implement Image";
    //} else if (imgOrSchematic == 2) {
    //  this.draggableSchematicTitle = "Schematic";
    //}
    const addSectionDialog = this.dialog.open(SchemanticCompTypePopupComponent, {
      width: '1080px',
      data: {
        schematic: schematic,
        implementId: this.selectedImplement,

      }
    });
    addSectionDialog.afterClosed().subscribe(r => {
      if (r) {
        this.loadImplementSchematics();
      }
    });

  }

  //edit observation point dialog
  openSchematicWindowforEdit(obserationID, imgOrSchematic) {

    if (imgOrSchematic == 1) {
      this.draggableSchematicTitle = "Implement Image";
    } else if (imgOrSchematic == 2) {
      this.draggableSchematicTitle = "Schematic";
    }
    this._implementService.GetSchematicDataForEditObsevationPoint(obserationID).subscribe(r => {

      if (r.length > 0) {
        this.selectedSchematicEdit = r[0]
        const addSectionDialog = this.dialog.open(SchemanticOpPopupEditComponent, {

          data: {
            schematic: this.selectedSchematicEdit,
            currentStep: this.currentStep,
            mouseoverOPId: this.mouseoverOPId,
            title: this.draggableSchematicTitle

          }
        });
        addSectionDialog.afterClosed().subscribe(details => {

        });

      }

    });


  }





  //GET-424
  //delete observation point
  deleteOP(op) {
    if (op.NumberOfReadings >= 1) {
      //check any readings exists
      this.check_op_has_any_readings(op.Id)
      //if not delete op

      //if exists disable button and alert
    } else {

    }


  }

  check_op_has_any_readings(op_id) {

    this._implementService.DeleteObservationPoint(op_id).subscribe((r: any) => {

      let json_ = JSON.parse(r)
      if (json_['status'] == true) {
        this.toastr.success(json_['message']);
        this.loadObservationPointsForImplement();
        //window.location.reload(false); 
      } else {
        this.toastr.error(json_['message']);
      }
    })


  }

  onCloseSchematicWindow(e) {
    this.showSchematic = false;
  }

  onSaveObservation(e) {
    //this.loadObservationPointsForImplement();
    //// this.loadImplementSchematics();
    //this.loadObservationLists();
    console.log("Auto Load:", e);
    this.loadGETComponents();
  }


  onMouseButton_Schematic(e) {
    this.isMouseDown = e.buttons === 1;
    e.preventDefault();

    this.prevMouseX = e.pageX;
    this.prevMouseY = e.pageY;
  }

  onMouseMove_Schematic(e) {
    if (this.isMouseDown) {

      if ((this.prevMouseX > 0) && (this.prevMouseY > 0)) {
        this.schematicPositionX += (e.pageX - this.prevMouseX);
        this.schematicPositionY += (e.pageY - this.prevMouseY);

        this.prevMouseX = e.pageX;
        this.prevMouseY = e.pageY;
      }

      else {
        this.prevMouseX = e.pageX;
        this.prevMouseY = e.pageY;
      }
    }
    e.preventDefault();
  }


  //////////////////////////////////////
  // Mouse hover logic for table rows //
  //////////////////////////////////////

  onMouseOverMP(id) {
    this.mouseoverMPId = id;
  }

  onMouseOutMP() {
    this.mouseoverMPId = 0;
  }

  onMouseOverOP(id) {
    this.mouseoverOPId = id;
  }

  onMouseOutOP() {
    this.mouseoverOPId = 0;
  }

  /////////////////////////
  // Tab 1 Radio buttons //
  /////////////////////////

  // Set up a new implement.
  setupNewImplement() {
    this.clearAll();
  }

  // Modify an existing implement.
  modifyImplement() {
    this.clearAll();
  }

  // Implement is on an equipment.
  loadOntoEquipment() {
    this.clearAll();
    this.IsTemplate = false;
  }

  // Implement is in inventory.
  createInInventory() {
    this.IsTemplate = false;

    // Only proceed if the jobsite is selected.
    if (this.selectedJobsite == null) {
      return;
    }

    this.clearAll();

    this._subscriptions.push(this._implementService.GetTemplateListForUserFilterByCustomer(this.selectedCustomer).subscribe(r => {

      this.implementTypeList = r;
    }));

    if (this.newOrExistingOption == this.pageConstants.IMPLEMENT_SETUP_NEW) {
      // New
    } else {
      // Existing
      this._subscriptions.push(this._implementService.GetImplementsInInventory(this.selectedJobsite).subscribe(r => {
        this.implementList = r;
      }));
    }
  }


  // Implement is in Template.
  createInTemplate() {
    // Only proceed if the jobsite is selected.
    if (this.selectedJobsite == null) {
      return;
    }

    this.clearAll();

    this._subscriptions.push(this._implementService.GetTemplateListForUserFilterByCustomer(this.selectedCustomer).subscribe(r => {
      console.log("GetTemplateListForUserFilterByCustomer", r)

      this.implementTypeList = r;
    }));

    if (this.newOrExistingOption == this.pageConstants.IMPLEMENT_SETUP_NEW) {
      // New
    } else {
      // Existing
      this._subscriptions.push(this._implementService.GetImplementsInInventory(this.selectedJobsite).subscribe(r => {
        this.implementList = r;
      }));
    }
    this.IsTemplate = true;
  }
  clearAll() {
    this.attachedImplementSelected = 0;
    this.selectedImplement = 0;
    this.selectedEquipment = 0;
    this.clearImplementDetails();
  }

  // Clear the Implement details.
  clearImplementDetails() {
    this.serialNumber = "";
    this.selectedImplementType = 0;
    this.prevSelectedImplementType = 0;
    this.selectedMake = 0;
    this.dateOfReading = new Date();
    this.implementHours = 0;
    this.equipmentSMU = 0;
    this.implementImage = '';
    this.schematicList = [];
  }

  ////////////////////
  // Tab 2 - update //
  ////////////////////

  validateImplementSerial() {
    this._implementService.ValidateImplementSerial(this.selectedImplement, this.serialNumber).subscribe(r => {
      if (!r) {
        this.toastr.error(this.pageErrors.ERROR_SERIALNO_VALIDATION_FAILED);
        this.serialNumber = "";
      }
    });
  }

  impDetails: ImplementDetails;
  // Gets the details of the selected implement.
  loadImplementDetails() {
    this.selectedModels = null;
    if (this.selectedImplement != 0) {
      this._subscriptions.push(this._implementService.GetImplementDetails(this.selectedImplement).subscribe(r => {
        //console.log("GetImplementDetails", r)
        this.impDetails = r;
        if (this.impDetails.CustomerId > 0) {
          this.getSeverityList();
        }

      }));
    }
  }
  createImplementDetailParams(): SaveImplementDetailParams {
    var details: ImplementDetails = new ImplementDetails();
    details.Id = this.selectedImplement;
    details.ImplementType = this.selectedImplementType;
    details.Make = this.selectedMake;
    details.SerialNo = this.serialNumber;
    details.SetupDate = this.dateOfReading.getDate() + "/"
      + (this.dateOfReading.getMonth() + 1) + "/" + this.dateOfReading.getFullYear();
    details.ImplementHoursAtSetup = this.impDetails.ImplementHoursAtSetup;
    details.EquipmentSMUAtSetup = this.impDetails.EquipmentSMUAtSetup;
    details.Hours = this.budgetHrs;
    details.Bcm = this.bcmHrs;
    details.Ton = this.tonHrs;
    details.purchaseCost = this.purchaseCost;
    details.IsTemplate = this.equipmentOrInventory == '3' ? true : false;
    details.GETType = this.selectedGETType;
    details.BucketCapacity = this.bucketCapacity;
    var params = new SaveImplementDetailParams();
    params.Details = details;
    params.EquipmentId = this.impDetails.EQId;
    params.JobsiteId = this.selectedJobsite;



    return params;
  }

  ////////////////
  // Navigation //
  ////////////////

  step1Validation(): ValidationErrorStatus {
    var validationResult: ValidationErrorStatus = new ValidationErrorStatus();
    validationResult.Status = true;
    validationResult.Message = "";

    if ((this.selectedCustomer == null) || (this.selectedCustomer <= 0)) {
      validationResult.Status = false;
      validationResult.Message = "Please select 'Customer'";
    }

    else if ((this.selectedJobsite == null) || (this.selectedJobsite <= 0)) {
      validationResult.Status = false;
      validationResult.Message = "Please select 'Jobsite'";
    }

    else if ((this.equipmentOrInventory == this.pageConstants.SETUP_ON_EQUIPMENT)
      && ((this.selectedEquipment == null) || (this.selectedEquipment <= 0))) {
      validationResult.Status = false;
      validationResult.Message = "Please select 'Equipment'";
    }

    else if ((this.newOrExistingOption == this.pageConstants.IMPLEMENT_SETUP_NEW)
      && (this.serialNumber.trim() == "")) {
      validationResult.Status = false;
      validationResult.Message = "Please select 'Implement'";
    }

    else if ((this.newOrExistingOption == this.pageConstants.IMPLEMENT_SETUP_EXISTING)
      && ((this.selectedImplement == null) || (this.selectedImplement <= 0))) {
      validationResult.Status = false;
      validationResult.Message = "Please select 'Implement'";
    }

    else if ((this.selectedMake == null) || (this.selectedMake <= 0)) {
      validationResult.Status = false;
      validationResult.Message = "Please select an Implement Make";
    }

    else if ((this.selectedModels == null) && this.equipmentOrInventory == '3') {
      validationResult.Status = false;
      validationResult.Message = "Please select Model";
    }

    else if (this.implementHours == null || this.implementHours < 0) {
      validationResult.Status = false;
      validationResult.Message = "Implement Hours is invalid!";
    }

    else if (this.equipmentSMU == null || this.equipmentSMU < 0) {
      validationResult.Status = false;
      validationResult.Message = "Equipment SMU is invalid!";
    }

    else if ((this.selectedImplementType == 0) && (this.NewimplementType == undefined || this.NewimplementType.trim().length == 0)) {
      validationResult.Status = false;
      validationResult.Message = "Please Enter/Select Implement Type";
    }

    else if ((this.selectedImplementType > 0) && !(this.NewimplementType == undefined || this.NewimplementType.trim().length == 0)) {
      validationResult.Status = false;
      validationResult.Message = "Can not select both 'Select Implement Type' and 'Create new Implement Type'";
    }

    if (this.ismodified == false) {
      if (this.purchaseCost == null) {
        this.purchaseCost = 0;
      }
      if (this.purchaseCost < 0) {
        validationResult.Status = false;
        validationResult.Message = "Purchased Cost is invalid!";
      }
    }

    // else if ((this.selectedModels === undefined) || (this.selectedModels.length == 0)) {
    //     validationResult.Status = false;
    //     validationResult.Message = "Please select compatible models.";
    // }

    return validationResult;
  }





  saveDefaultImage() {
    var defaultImageType = 0;
    var implementType = this.implementTypeList.find(f => f.TemplateId == this.selectedImplementType);

    if (this.selectedImplement <= 0) {
      return;
    }

    this._implementService.SaveDefaultImplementImage(this.selectedImplement).subscribe(r => {
      if (r.m_Item1) {
        this.loadImplementImage();
      }
    });
  }







  validateAndProcessTab2() {
    this.loadComponentsAndObservationPoints();
    this.currentStep = 2;
  }


  // Validate components.
  validateComponents() {
    var validationResult: ValidationErrorStatus = new ValidationErrorStatus();
    validationResult.Status = true;
    validationResult.Message = "";

    for (var i = 0; i < this.componentList.length; i++) {
      if (this.componentList[i].SchematicId == null || this.componentList[i].SchematicId < 1) {
        validationResult.Message = this.pageErrors.ERROR_COMPONENT_TYPE_SCHEMATIC_MAP_MISSING;
        validationResult.Status = false;
      }
      if (this.componentList[i].Name == null || this.componentList[i].Name.trim().length == 0) {
        validationResult.Message = this.pageErrors.ERROR_COMPONENT_NAME_MISSING;
        validationResult.Status = false;
      }
      // if (this.componentList[i].PartNo == null || this.componentList[i].PartNo.trim().length == 0) {
      //     validationResult.Message = this.pageErrors.ERROR_COMPONENT_PART_MISSING;
      //     validationResult.Status = false;
      // }
      // if (this.componentList[i].CompTypeId == null || this.componentList[i].CompTypeId == 0) {
      //     validationResult.Message = this.pageErrors.ERROR_COMPONENT_TYPE_MISSING;
      //     validationResult.Status = false;
      // }
      // if (this.componentList[i].MakeId == null || this.componentList[i].MakeId == 0) {
      //     validationResult.Message = this.pageErrors.ERROR_COMPONENT_MAKE_MISSING;
      //     validationResult.Status = false;
      // }
    }

    return validationResult;
  }






  HasChildImplements: boolean
  //check implement is copyfrom
  CheckSelectedImplementCopyFrom() {
    this._implementService.CheckhasCopyFrom(this.selectedImplement).subscribe(res => {
      console.log("resulttt", res)
      if (res) {
        this.cbApplyToOne = false;
        this.cbApplyToAll = false;
        this.HasChildImplements = true;
      } else {
        this.cbApplyToOne = true;
        this.cbApplyToAll = false;
        this.HasChildImplements = false;
      }
    })
  }
  // Save changes to components.
  saveComponents() {
    var validationResult: ValidationErrorStatus = new ValidationErrorStatus();
    validationResult.Status = true;
    validationResult.Message = "";

    validationResult = this.validateComponents();

    var params: SaveComponentParams = new SaveComponentParams();
    params.ImplementId = this.attachedImplementSelected;
    params.Components = this.componentList;

    if (validationResult.Status) {
      this._implementService.SaveComponents(params).subscribe(r => {

        if (r == false) {
          this.loading = false;

          this.toastr.error(this.pageErrors.ERROR_SAVING_MP);
        } else {
          this.validateAndProcessTab2();
          var params1 = this.createImplementDetailParams();
          params1.Details.Id = this.attachedImplementSelected;

          //new code
          params1.Details.Id = this.attachedImplementSelected;//c.implementId;
          params1.Details.ImplementHoursAtSetup = this.impDetails.ImplementHoursAtSetup;;
          params1.Details.SetupDate = this.impDetails.SetupDate;
          params1.Details.purchaseCost = this.impDetails.purchaseCost;
          if (this.impDetails.EQId > 0) {
            params1.EquipmentId = this.impDetails.EQId;
            params1.Details.EquipmentSMUAtSetup = this.impDetails.EquipmentSMUAtSetup

          }
          //ened new code



          this._implementService.CreateImplementSetupEvent(params1).subscribe(r => {
            if (r < 0) {
              this.loading = false;

              this.toastr.error(this.pageErrors.ERROR_SAVING_SETUP_EVENT);
            } else {
              //navigate
              this.loading = false;
              this._router.navigate(['setup/implement-observation/' + this.selectedImplement]);
            }
          });
        }
      });
    } else {
      this.loading = false;
      this.toastr.error(validationResult.Message);
    }
  }

  // Saves any changes made to observation points.
  saveObservationPoints() {
    var params: SaveObservationPointParams = new SaveObservationPointParams();
    params.GetAuto = this.attachedImplementSelected;
    params.ObservationPoints = this.observationPoints;

    this._implementService.SaveObservationPoints(params).subscribe(r => {
      if (r < 0) {
        this.toastr.error(this.pageErrors.ERROR_SAVING_OP);
      } else {
        // Now mark setup as complete.
        this.setupComplete = true;
      }
    })
  }


  // For 'Setup on equipment' ensure that customer, jobsite and equipment selections have been made.
  // For 'Setup in inventory' ensure that customer and jobsite are selected.
  // Otherwise validation fails.
  stepTwoIsValid(): boolean {
    return true;
  }

  stepThreeIsValid(): boolean {
    return true;
  }


  // Setup another implement after submitting data.
  navigateToSetupImplements() {
    this._router.navigate(['setup/implement']);
    this.clearAll();
    this.currentStep = 0;
    this.setupComplete = false;
  }

  // Navigate to the dashboard (My Implements) page after finishing setup.
  navigateToMyImplements() {
    window.location.href = 'https://' + this.oldGetUrl + '/GET/MyImplements.aspx?';
  }




  //update the observation to all the implements
  savedallSucess: boolean = false







  checkExistingOP(val) {
    let count = 0
    if (val.trim().length < 1 || val == "") {
      this.toastr.error('The Observation name cannot be empty');
      //this.isvalidStep3 = false
      // return
    }
    this.observationPoints.map(x => {
      if (x.Name.toLowerCase() == val.toLowerCase()) {
        count = count + 1;
      }

    })
    if (count > 1) {
      this.toastr.error('This Observation name already exists!');
      //this.isvalidStep3 = false
      //return
    }
  }



  returnIndexOfItem(id, isNew) {
    for (var i = 0; i < this.schematicList.length; i++) {
      var x = this.schematicList[i];
      if (x.Id == id && x.IsNewImage == isNew) {
        return i;
      }
    }

    return -1;
  }

  deleteimage(id, isNew, OBSCount) {
    if (OBSCount == 0) {
      const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
        width: '400px',
        data: {
          title: 'Delete Schematic',
          message: "This schematic will be permanently deleted. Do you want to continue?"
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result?.confirmed) {
          if (isNew) {
            var index = this.returnIndexOfItem(id, isNew);
            if (index >= 0) {
              this.schematicList.splice(index, 1);
            }
          } else {
            this._implementService.DeleteImplementSchematicImage(id, this.selectedImplement).subscribe(r => {
              if (r) {
                var index = this.returnIndexOfItem(id, isNew);
                if (index >= 0) {
                  this.schematicList.splice(index, 1);
                  this.loadImplementSchematics();
                }
              } else {
                this.toastr.error("Unable to delete schematic!");
              }
            });
          }
        }
      });
    }
    if (OBSCount > 0) {
      this.toastr.error('This schematic currently has Observation points allocated!');
    }
  }

  ValidateNumberInputs(e) {
    if ((e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode == 110 || e.keyCode == 190 || e.keyCode == 46) {
      return true;
    }
    return false;
  }
  //   onKeyDown(event: KeyboardEvent,comp:ComponentVM) {
  //     console.log(event.code)
  // comp.Name = comp.Name + event.code;
  //     if (event.code === 'Space') {
  //       // handle space key press event here
  //     }
  // }



  //uplaod OPQuestion Image

  selectedFile: File
  ModelImage_fromPC: string
  QuestionImage: string
  onSelectOPQuestionImage(event: any, id: number) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.selectedFile = event.target.files[0];
      reader.onloadend = (e) => {
        this.uploadPhoto(reader.result as string, id);

      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  uploadPhoto(newPhoto: string, ID: number) {
    this.ModelImage_fromPC = newPhoto.split(",")[1];

    var saveParams: SaveQuestionImageParams = new SaveQuestionImageParams();
    saveParams.ObservationPointId = ID;
    saveParams.ImageData = this.ModelImage_fromPC;

    this._subscriptions.push(this._implementService.SaveQuestionImage(saveParams).subscribe(r => {
      if (r) {
        this.observationPoints.filter(x => {
          if (x.Id == ID) {
            x.QuestionImage = this.ModelImage_fromPC;
            x.IsNewImage = true;
            this.toastr.success("Uploaded successfully")
          }
        })
      }
    }));


  }

  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }


  UpdateSchmaticImageName(schematic: SchematicDataVM) {
    this._implementService.UpdateSchmaticImageName(schematic.Id, schematic.ImageName).subscribe(res => {
      if (res > 0)
        this.toastr.success("Updated successfully")
    })
  }



  isCriticalChangedevent(event) {
    console.log("1", event.checked)
    console.log("1", this.isGETCritical)
    console.log("1", this.newComponentCritical)
    if (event.checked == true && this.isGETCritical == true) {

      this.isGETCritical = false
    }


  }
  isGETChangedevent(event) {
    if (event.checked == true && this.newComponentCritical == true) {

      this.newComponentCritical = false
    }
  }



  SaveComponent() {
    this.loading = true;
    //this.saveSchemanticImages();
    this.saveComponents();
  }


  getColorCodes() {
    this._implementService.getColorCodes().subscribe(res => {
      this.colorCodeList = res

    })
  }


  getSeverityList() {
    this._implementService.getSeverityList(this.impDetails.CustomerId).subscribe(res => {
      this.SeverityList = res

    })
  }
  skipChanges() {
    this._router.navigate(['setup/implement-observation/' + this.selectedImplement])
  }

  allowSpaces(event: KeyboardEvent) {
    // Allow spaces to be entered
    if (event.keyCode === 32) {
      event.stopPropagation();
    }
  }

  openPopup(schematic: SchematicDataVM) {
    this.dialog.open(SchematicCompsMarkingComponent, {
      width: '1400px',
      data: {
        implementId: this.selectedImplement,
        schematicId: schematic.Id,
        schematic: schematic.Data
      }
    });
  }

  isComponentTypeAssociated(typeId: number): boolean {

    if (!this.newComponentSchematicId) {
      return false;
    }

    const schematic = this.schematicList.find(
      x => x.Id == this.newComponentSchematicId
    );

    if (!schematic?.ComponentTypeIds) {
      return false;
    }

    const ids = schematic.ComponentTypeIds
      .split(',')
      .map((x: string) => Number(x));

    return ids.includes(typeId);
  }

  isSchematicAssociated(schematic: any): boolean {

    if (!this.newComponentTypeId) {
      return false;
    }

    if (!schematic?.ComponentTypeIds) {
      return false;
    }

    const ids = schematic.ComponentTypeIds
      .split(',')
      .map((x: string) => Number(x));

    return ids.includes(Number(this.newComponentTypeId));
  }

  openHideConfirmationBox(schematicId: number, schematicsName: string, IsHidden: boolean) {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      width: '400px',
      data: {
        title: !IsHidden ? 'Hide Schematic' : 'Unhide Schematic',
        message: `Are you sure you want to ${!IsHidden ? 'hide' : 'unhide'} this schematic?\n\n${schematicsName}`
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        this._implementService.hideSchematic(this.selectedImplement, schematicId, !IsHidden).subscribe((r: any) => {
          let json_ = JSON.parse(r)
          if (r && r.includes("Cannot")) {
            console.log('r', r)
            this.toastr.error(r);
            //window.location.reload();
          } else if (r) {
            this.toastr.success(r);
            window.location.reload();
          } else {
            this.toastr.error("There is an error while ${!IsHidden ? 'hiding' : 'unhiding'} this schematic.");
          }
        })
      }
    });
  }

  get visibleSchematics(): SchematicDataVM[] {
    return this.schematicList.filter(x => !x.IsHidden);
  }


}



/////////////////
// File Reader //
/////////////////
export interface FileReaderEventTarget extends EventTarget {
  result: string;
}

export interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}


